module.exports = __webpack_public_path__ + "static/Sezane2-c0e22425873cd40a96261ae9eb8a07ee.jpg";